export const EmptyDirectoryImage = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      viewBox="0 0 190 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <path
        d="M152.465 159.315L34.2521 152.572C32.5484 152.475 31.2688 150.978 31.4376 149.28L44.7929 14.9834C44.952 13.3836 46.3439 12.1936 47.949 12.2852L138.667 17.4595C139.408 17.5017 140.106 17.8165 140.628 18.3433L163.584 41.5163C164.197 42.1359 164.511 42.992 164.443 43.8615L155.626 156.554C155.499 158.181 154.094 159.408 152.465 159.315Z"
        fill="#FAFCFF"
        stroke="#1A1C35"
        strokeWidth="2"
      />
      <path
        d="M163.415 41.7399L140.491 19.134L135.436 41.8249L163.415 41.7399Z"
        fill="#BDD2FF"
        stroke="#1A1C35"
        strokeWidth="1.5"
      />
      <path
        d="M142.677 171.778L36.0799 180.484C34.4092 180.621 32.9508 179.362 32.842 177.689L23.9826 41.3854C23.877 39.7614 25.0855 38.3494 26.7064 38.203L107.866 30.8717C108.58 30.8073 109.292 31 109.876 31.4151L136.82 50.5856C137.556 51.1096 138.017 51.9378 138.074 52.8399L145.426 168.598C145.53 170.23 144.307 171.645 142.677 171.778Z"
        fill="#F3F6FD"
        stroke="#1A1C35"
        strokeWidth="2"
      />
      <path
        d="M41.3314 68.486L102.41 63.7135"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M41.6661 85.9563L122.501 79.354"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M43.4388 102.953L107.354 97.7322"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M45.1221 120.873L125.957 114.271"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M45.4723 137.372L123.019 131.038"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M46.9425 154.83L125.761 148.393"
        stroke="#1A1C35"
        strokeWidth="2.4"
        strokeLinecap="square"
      />
      <path
        d="M134.973 51.3493L136.795 51.076L135.3 49.9984L110.781 32.3126L109.602 31.4619L109.593 32.917L109.469 54.3007L109.464 55.1771L110.33 55.0472L134.973 51.3493Z"
        fill="#2B5FCE"
        stroke="#1A1C35"
        strokeWidth="1.5"
      />
    </svg>
  )
}
